import React, { useState, useEffect } from "react";
import { Select, Input, Space, Form } from "antd";
import FormItem from "components/fields/FormItem";

const SelectWithOthers = (props) => {
  const {
    selectFieldName,
    selectOptions,
    selectDisplayValue, 
    othersFieldName,
    othersDisplayValue, 
    mode,
    optionOthersId,
    onChangeHandler,
    othersPlaceholder,
    othersPlaceholders,
    othersStyle,
    direction,
  } = props;

  const form = Form.useFormInstance();
  const selectedValue = Form.useWatch(selectFieldName, form);

  const [placeholder, setPlaceholder] = useState(
    othersPlaceholder ?? "Please specify"
  );

  useEffect(() => {
    if (othersPlaceholders && optionOthersId.includes(selectedValue)) {
      setPlaceholder(othersPlaceholders[selectedValue] ?? "Please specify");
    }
  }, [selectedValue, optionOthersId, othersPlaceholders]);

  return (
    <Space.Compact block direction={direction ?? "horizontal"} wrap="true">
      <FormItem name={selectFieldName} noStyle>
        {mode === "edit" ? (
          <Select
            id={selectFieldName}
            options={selectOptions}
            className="input-field"
            showSearch
            allowClear
            onChange={(val) => {
              if (onChangeHandler) onChangeHandler(val);
            }}
          />
        ) : (
          <label className="ps-3 dark:text-white">{selectDisplayValue}</label>
        )}
      </FormItem>

      {optionOthersId.includes(selectedValue) && (
        <FormItem name={othersFieldName} noStyle>
          {mode === "edit" ? (
            <Input
              id={othersFieldName}
              placeholder={placeholder}
              defaultValue={othersDisplayValue}
              className={`input-field ${direction === "vertical" ? "mt-3" : ""}`}
              style={othersStyle}
            />
          ) : (
            <label className="ps-3 dark:text-white">{othersDisplayValue}</label>
          )}
        </FormItem>
      )}
    </Space.Compact>
  );
};

export default SelectWithOthers;